export const FRENCH_REGIONS = [
  { code: 'ARA', name: 'Auvergne-Rhône-Alpes' },
  { code: 'BFC', name: 'Bourgogne-Franche-Comté' },
  { code: 'BRE', name: 'Bretagne' },
  { code: 'CVL', name: 'Centre-Val de Loire' },
  { code: 'COR', name: 'Corse' },
  { code: 'GES', name: 'Grand Est' },
  { code: 'HDF', name: 'Hauts-de-France' },
  { code: 'IDF', name: 'Île-de-France' },
  { code: 'NOR', name: 'Normandie' },
  { code: 'NAQ', name: 'Nouvelle-Aquitaine' },
  { code: 'OCC', name: 'Occitanie' },
  { code: 'PDL', name: 'Pays de la Loire' },
  { code: 'PAC', name: "Provence-Alpes-Côte d'Azur" },
  { code: 'GUA', name: 'Guadeloupe' },
  { code: 'MTQ', name: 'Martinique' },
  { code: 'GUF', name: 'Guyane' },
  { code: 'LRE', name: 'La Réunion' },
  { code: 'MAY', name: 'Mayotte' },
]
